// extracted by mini-css-extract-plugin
module.exports = {"subMenu":"styles_subMenu___OkHz","link":"styles_link__IZ1-a","active":"styles_active__2i3aI","activeIndicator":"styles_activeIndicator__1hI9n"};